export const data={
    userName:'',
    password:'',
    remember: true,
}